import Title from '../components/main/Title'
import clock from '../assets/icons/clock1.png'
import diamond from '../assets/icons/diamond.png'
import target from '../assets/icons/target.png'
import ValueBox from '../components/about-us/ValueBox'
import BlueBaner from '../components/main/BlueBaner'
import DoctorsSection from '../components/contact-us/DoctorsSection'
import CounterNumbersBox from '../components/contact-us/CounterNumbersBox'
import CommentsSection from '../components/contact-us/CommentsSection'
import { useEffect } from 'react'
import { ABOUT_PAGE } from '../data/texts'

const AbouUsPage = () => {

    const data = ABOUT_PAGE
     useEffect(() => {
        window.scrollTo(0, 0)
        }, [])
        
    return(
      <div className='flex justify-center'>
         <div className=' w-full flex flex-col gap-12'>
            <BlueBaner
            title={data.title}
            text={data.description}
            />
            <div className='flex flex-col lg:flex-row lg:gap-20'>
                <div className='flex flex-col gap-8 lg:w-1/3'>
                    <ValueBox
                    img={clock}
                    title={'تاریخچه‌ ما'}
                    text={data.history}
                    />
                    <ValueBox
                    img={diamond}
                    title={'ارزش ما'}
                    text={data.value}
                    />
                    <ValueBox
                    img={target}
                    title={'هدف ما'}
                    text={data.goal}
                    />
                </div>
                <div className='lg:w-2/3 mt-12 lg:mt-0 '>
                <h3 className=" text-[20px] font-semibold text-[#383838]
                border-b border-b-[#D2D2D2] pb-4 mb-4">
                    <span>
                        با 
                    </span>
                    <Title text={' مدیزن '}/>
                    <span>
                    آشنا شوید!
                    </span>
                </h3>
                <p className='text-justify leading-[30px]'>
                    {data.moreDesc}
                </p>
                </div>
              
            </div>
            <DoctorsSection/>
            <CommentsSection/>
           <CounterNumbersBox/>
       </div>
      </div>
    )
}
export default AbouUsPage